/**
 * Get the set difference of two arrays. (A without the overlapping members from B)
 * ```typescript
 *   difference([1, 2, 3], [3, 4, 5]); // === [1, 2]
 * ```
 */
export function difference<T>(a: T[], b: T[]): T[] {
  return a.filter((el) => !b.includes(el));
}
